import React, { useState } from 'react'
import './index.scss'
import RelinquishmentConfirmationPopup from '@Components/Popups/RelinquishmentConfirmationPopup'
import ModalPortal from '@Components/Popups/ModalPortal'
import MlcTooltip from '@Components/Tooltips/MlcTooltip'
import DisputeOptionItem from '@Components/OverclaimView/DisputeOptionSection/DisputeOptionItem'
import { useFlag } from '@openfeature/react-sdk'

export interface DisputeOptionSectionProps {
    onClickEmailOption: () => void
    onClickAmendOption: () => void
    onClickUploadDocumentsOption: () => void
    isExistingRelinquishment?: boolean
}

const DisputeOptionSection = ({
    onClickEmailOption,
    onClickAmendOption,
    isExistingRelinquishment,
    onClickUploadDocumentsOption,
}: DisputeOptionSectionProps) => {
    const [displayRelinquishPopup, setDisplayRelinquishPopup] = useState<boolean>(false)
    const { value: showDocumentUpload } = useFlag('overclaim-document-upload', false)

    return (
        <div className="overclaim-item-bottom-section">
            <ModalPortal isOpen={displayRelinquishPopup}>
                <RelinquishmentConfirmationPopup onClose={() => setDisplayRelinquishPopup(false)} />
            </ModalPortal>
            <div className="overclaim-item-bottom-content">
                <h5>You can choose to:</h5>
                <div className="options-row">
                    <DisputeOptionItem
                        title="Option 1 - Email All Claimants"
                        body="You can send an email to all claimants involved on this work to attempt to resolve the overclaim."
                        onClick={onClickEmailOption}
                        buttonText="Email"
                        disabled={isExistingRelinquishment}
                    />
                    <DisputeOptionItem
                        title="Option 2 - Amend Shares"
                        body="Amend your shares on this work to an amount that makes the total shares equal 100% or less."
                        onClick={onClickAmendOption}
                        buttonText="Amend Shares"
                        disabled={isExistingRelinquishment}
                    />
                    <MlcTooltip variant="info" place="top" id="relinquishment-disabled-tooltip">
                        <span>
                            You have already relinquished your shares for this overclaim. Please wait 1-2 days for
                            processing.
                        </span>
                    </MlcTooltip>
                    <DisputeOptionItem
                        title="Option 3 - Relinquish Shares"
                        body="Relinquish all shares on this work."
                        onClick={() => setDisplayRelinquishPopup(true)}
                        buttonText="Relinquish Shares"
                        dataTooltipId={isExistingRelinquishment ? 'relinquishment-disabled-tooltip' : undefined}
                        disabled={isExistingRelinquishment}
                    />
                    {showDocumentUpload && (
                        <DisputeOptionItem
                            title="Option 4 - Upload Documents"
                            body="Upload documents on this work to support your claim on this work."
                            onClick={onClickUploadDocumentsOption}
                            buttonText="Upload Documents"
                            disabled={isExistingRelinquishment}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default DisputeOptionSection
